import * as React             from 'react';
import * as cx                from 'classnames';
import { EditableFieldProps } from './EditableFieldTypes';

const EditableField: React.StatelessComponent<EditableFieldProps> = ({ messageTemplate, currentField, handleEdit, selectedField, currentIndex, fieldName, selectCF }) => (
    <span
        contentEditable
        data-fieldname={fieldName}
        id={`${messageTemplate.id}-${currentField.key}`}
        className={cx('messageTemplate__input', {
            'messageTemplate__input-placeholder-invalid': !currentField.isValid,
            'messageTemplate__input-placeholder-empty': !currentField.editedValue || !currentField.editedValue.length
        })}
        key={`${messageTemplate.id}${currentIndex}`}
        onInput={(event: React.SyntheticEvent<HTMLElement>) => handleEdit({ fieldKey: selectedField, value: event.currentTarget.innerText })}
        onBlur={(event: React.SyntheticEvent<HTMLElement>) => handleEdit({ fieldKey: selectedField, value: event.currentTarget.innerText, focusChange: true })} // focusChange indicates that the value can be reset if an empty string is passed through
        onSelect={() => selectCF(fieldName, messageTemplate.id)}
    />
);

export default EditableField;



// WEBPACK FOOTER //
// ./src/sections/EditableField/EditableField.tsx